import PropTypes from 'prop-types';
import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useCallback,
} from 'react';

import { debounceEvent } from 'pubweb-smokey/dist/utils/utils';
import { SuggestionBox } from '@components/Shared/DropDownList/DropDownList';

import { getLocationsFromSearch } from '@services/locationService';
import { LocationsContext } from '@contexts/LocationsContext';

import { CityLocationSuggestionStyles } from './CityLocationSuggestion.styled';

const CityLocationSuggestion = ({
  onChange,
  label = 'Enter location',
  ...props
}) => {
  const locationsContext = useContext(LocationsContext);
  const [zipText, setZipText] = useState();
  const [locations, setLocations] = useState([]);
  const textBoxRef = useRef();

  const handleTextChange = () => {
    setZipText(textBoxRef.current.value);
    getLocations();

    if (onChange) {
      onChange(textBoxRef.current.value);
    }
  };

  const getLocations = useCallback(
    debounceEvent(() => {
      if (textBoxRef.current && textBoxRef.current.value.length >= 3) {
        getLocationsFromSearch(textBoxRef.current.value).then((result) => {
          setLocations(
            result.map((l) => {
              return {
                text: `${l.city}, ${l.state} ${l.postalCode}`,
                value: l.postalCode,
              };
            })
          );
        });
      } else {
        setLocations([]);
      }
    }, 250),
    []
  );

  useEffect(() => {
    setZipText(locationsContext.state.postalCode);
  }, [locationsContext]);

  return (
    <CityLocationSuggestionStyles className="city-location-suggestion">
      <SuggestionBox
        label={label}
        itemTextDisplay="value"
        items={locations}
        onKeyPress={(e) => {
          if (e.charCode === 13 && locations.length > 0) {
            setZipText(locations[0].value);

            if (onChange) {
              onChange(locations[0].value);
            }
          }
        }}
        onChange={(e) => {
          setZipText(e.value);
          setLocations([]);

          if (onChange) {
            onChange(e.value);
          }
        }}
        textBoxRef={textBoxRef}
        selectedItem={zipText}
        onTextChange={handleTextChange}
        automationId="city-location-suggestion"
        {...props}
      />
    </CityLocationSuggestionStyles>
  );
};

CityLocationSuggestion.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default CityLocationSuggestion;
